import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { selectors as brandSelectors } from "../../../../redux/brand";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

const StyledInstructions = styled.div`
  margin: 10px 0 10px 0;
`;

const Instructions = ({ signInInstructions }) => {
  if (signInInstructions) {
    return (
      <div>
        <StyledInstructions>
          <ReactMarkdown
            linkTarget="_blank"
            rehypePlugins={[rehypeRaw]}
          >
            {signInInstructions}
          </ReactMarkdown>
        </StyledInstructions>
      </div>
    );
  }
  return null;
};

const mapStateToProps = state => ({
  signInInstructions: brandSelectors.getBrandValue(
    state,
    "Signin.instructions",
    false
  )
});

export default connect(mapStateToProps)(Instructions);
